// Vendor imports
const Immutable = require('immutable')
// Common Client V2 imports
const {
  listReviver,
  keyedReviver
} = require('client-v2/common/state/record-reviver')
// Container imports
const { wrapFeedStream } = require('../wrappers')
// Sibling imports
const FeedItemRecord = require('./item')
const FeedStreamMetaRecord = require('./stream-meta')

class FeedStreamRecord extends Immutable.Record({
  isNextPageLoading: Boolean(),
  items: Immutable.List(),
  meta: new FeedStreamMetaRecord()
}) {

  get isNextPageAvailable() {
    return !!this.nextPageUrl && !this.isNextPageLoading
  }

  get nextPageUrl() {
    return this.getIn(['meta', 'nextUrl'])
  }

  appendNextPage(feedStreamPage) {
    const { items, meta } = wrapFeedStream(feedStreamPage)
    return this.mergeDeep({
      isNextPageLoading: false,
      items: Immutable.fromJS(items, itemsReviver),
      meta
    })
  }

  getDenormalizedItems(pageContextOverlay) {
    return this.items.map(item => {
      return item.denormalize(this.meta, pageContextOverlay)
    })
  }

  removeArticlesByUrlIds(urlIds) {
    return this.update('items', oldItems => {
      const newItems = oldItems.filter(item => {
        if (item.article) {
          return !urlIds.includes(item.id)
        }
        return true
      })
      return newItems.size < oldItems.size ? newItems : oldItems
    })
  }

  removeArticlesByHostname(hostname) {
    if (!this.meta.recBatchId && !this.meta.urlRecBatchId) {
      // Only apply domain blocks to recommended feeds
      return this
    }
    return this.update('items', oldItems => {
      const newItems = oldItems.filter(item => {
        if (item.article) {
          return item.article.hostname !== hostname
        }
        return true
      })
      return newItems.size < oldItems.size ? newItems : oldItems
    })
  }

  itemsReducer(action) {
    return this.update('items', oldItems => {
      let itemsModified = false
      const newItems = oldItems.map(oldItem => {
        const newItem = oldItem.reducer(action)
        itemsModified = itemsModified || oldItem !== newItem
        return newItem
      })
      return itemsModified ? newItems : oldItems
    })
  }

  setNextPageFailed() {
    return this.mergeDeep({
      isNextPageLoading: false,
      meta: { nextUrl: null }
    })
  }

  setNextPageLoading() {
    return this.merge({
      isNextPageLoading: true
    })
  }

}

const itemsReviver = listReviver(FeedItemRecord.reviver)
const reviver = keyedReviver(FeedStreamRecord, {
  items: itemsReviver,
  meta: FeedStreamMetaRecord.reviver
})

module.exports = Object.assign(FeedStreamRecord, {
  itemsReviver,
  reviver
})
